import React, { useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import courseMenus from "./courseNavigation";

const dropdownStyle = {
  width: "16em",
  top: "1.5em",
  position: "absolute",
  background: "rgb(0,0,0,80%)",
  padding: "1em",
  overflow: "scroll",
};

const toggleStyle = {
  background: "none",
  border: "none",
  padding: 0,
  marginRight: "1em",
  textDecoration: "none",
  whiteSpace: "nowrap",
  cursor: "pointer",
  color: "inherit",
  font: "inherit",
};

const linkStyle = {
  width: "100%",
  display: "block",
  textDecoration: "none",
  margin: "1em auto",
  textAlign: "center",
};

function DropdownLink({ item, closeMenu }) {
  if (item.href) {
    return (
      <a
        href={item.href}
        target="_blank"
        rel="noreferrer noopener"
        style={linkStyle}
        onClick={closeMenu}
      >
        {item.label}
      </a>
    );
  }

  return (
    <Link onClick={closeMenu} to={item.to} style={linkStyle}>
      {item.label}
    </Link>
  );
}

function CourseDropdown({ menu, isOpen, menuRef, toggleMenu, closeMenu }) {
  return (
    <div style={{ position: "relative" }} ref={menuRef}>
      <button
        type="button"
        style={toggleStyle}
        onClick={() => toggleMenu(menu.id)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        {menu.label} ↓
      </button>

      {isOpen && (
        <div style={{ ...dropdownStyle, ...menu.position }}>
          {menu.sections.map((section) => (
            <React.Fragment key={section.label}>
              {section.label && <p className="navSeparator">
                <strong>{section.label}&nbsp;↓</strong>
              </p>}

              {section.links.map((item) => (
                <DropdownLink
                  key={item.to || item.href}
                  item={item}
                  closeMenu={closeMenu}
                />
              ))}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

function Navbar() {
  const [openMenu, setOpenMenu] = useState(null);

  const aiCoursesRef = useRef(null);
  const designCoursesRef = useRef(null);
  const codingCoursesRef = useRef(null);
  const gameDevCoursesRef = useRef(null);
  const companiesRef = useRef(null);
  const schoolRef = useRef(null);

  const courseMenuRefs = {
    aiCourses: aiCoursesRef,
    designCourses: designCoursesRef,
    codingCourses: codingCoursesRef,
    gameDevCourses: gameDevCoursesRef,
  };

  useEffect(() => {
    function handleClickOutside(event) {
      const refs = {
        aiCourses: aiCoursesRef,
        designCourses: designCoursesRef,
        codingCourses: codingCoursesRef,
        gameDevCourses: gameDevCoursesRef,
        companies: companiesRef,
        school: schoolRef,
      };

      if (!openMenu) return;

      const activeRef = refs[openMenu];
      if (activeRef?.current && !activeRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenu]);

  const toggleMenu = (menuName) => {
    setOpenMenu((prev) => (prev === menuName ? null : menuName));
  };

  const closeMenu = () => {
    if (openMenu !== null) {
      setOpenMenu(null);
    }
  };

  return (
    <div className="nav navbarDesktop">
      {courseMenus.map((menu) => (
        <CourseDropdown
          key={menu.id}
          menu={menu}
          isOpen={openMenu === menu.id}
          menuRef={courseMenuRefs[menu.id]}
          toggleMenu={toggleMenu}
          closeMenu={closeMenu}
        />
      ))}

      <div style={{ position: "relative" }} ref={schoolRef}>
        <button
          type="button"
          style={toggleStyle}
          onClick={() => toggleMenu("school")}
          aria-expanded={openMenu === "school"}
          aria-haspopup="true"
        >
          School ↓
        </button>

        {openMenu === "school" && (
          <div style={{ ...dropdownStyle, right: "0" }}>

            <Link
              onClick={closeMenu}
              to="/events/ai-agent-workshop-barcelona/"
              style={linkStyle}
            >
              Events
            </Link>

            <Link
              onClick={closeMenu}
              to="/about-us/testimonials/"
              style={linkStyle}
            >
              Testimonials
            </Link>

            <Link
              onClick={closeMenu}
              to="/about-us/instructors/"
              style={linkStyle}
            >
              Instructors
            </Link>

            <Link
              onClick={closeMenu}
              to="/about-us/career-services/"
              style={linkStyle}
            >
              Career services
            </Link>

            <Link onClick={closeMenu} to="/about-us/school/" style={linkStyle}>
              About us
            </Link>

            <Link onClick={closeMenu} to="/blog/" style={linkStyle}>
              Blog
            </Link>

            <Link onClick={closeMenu} to="/lab/" style={linkStyle}>
              BCS Lab
            </Link>

            <Link onClick={closeMenu} to="/contacts/" style={linkStyle}>
              Contact us
            </Link>
          </div>
        )}
      </div>

      <div style={{ position: "relative" }} ref={companiesRef}>
        <button
          type="button"
          style={{ ...toggleStyle, marginRight: 0 }}
          onClick={() => toggleMenu("companies")}
          aria-expanded={openMenu === "companies"}
          aria-haspopup="true"
        >
          For companies ↓
        </button>

        {openMenu === "companies" && (
          <div style={{ ...dropdownStyle, right: "0" }}>
            <Link
              onClick={closeMenu}
              to="/ai-implementation-in-barcelona-code-school/"
              style={linkStyle}
            >
              AI implementation
            </Link>
            <Link
              onClick={closeMenu}
              to="/corporate-training/"
              style={linkStyle}
            >
              Training and development
            </Link>

            <Link onClick={closeMenu} to="/job-offer/" style={linkStyle}>
              Hire graduates
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar;
